import { stubTrue } from 'lodash';
import { setSelectedRows } from 'modules/campaigns/modules/campaigns-reports/actions';
import {
    CheckboxCellRenderer,
    CheckboxHeaderRenderer,
    EllipsisCellRenderer,
    FormattedMessageHeaderRenderer,
    IMAGE_CELL_RENDERER_MODES,
    ImageCellRenderer,
    StateCellRenderer,
    withCreativeEditIndication,
} from 'modules/campaigns/modules/campaigns-reports/components';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import {
    checkBoxSelectionColumn,
    editableColumn,
    leftPinnedColumn,
    lockedColumn,
    staticColumn,
    toggleColumn,
} from '../../columns';
import * as FIELDS from '../../fields';
import { CREATIVE_LIBRARY_REPORT_ID } from './creativeLibraryReportId';

const creativeLibraryReportColumnDefinition = [
    {
        headerComponentFramework: CheckboxHeaderRenderer,
        headerName: FIELDS.IS_SELECTED.label,
        field: FIELDS.IS_SELECTED.field,
        type: [leftPinnedColumn, checkBoxSelectionColumn, staticColumn],
        cellRendererParams: {
            onClick: setSelectedRows,
        },
        headerComponentParams: {
            onClick: setSelectedRows,
        },
        valueGetter: FIELDS.IS_SELECTED.valueGetter,
        cellRendererFramework: CheckboxCellRenderer,
        csv: false,
        permissions: {
            permissions: ['CAMPAIGNS_ITEMS_BULK_UPDATE'],
        },
        accountConfigurations: {
            [FEATURE_FLAGS.CREATIVES_BULK_ACTIONS_ENABLED]: 'true',
        },
    },
    {
        headerName: FIELDS.IS_ACTIVE.label,
        field: FIELDS.IS_ACTIVE.field,
        type: [lockedColumn, toggleColumn, leftPinnedColumn, staticColumn],
        cellRendererParams: {
            ...FIELDS.IS_ACTIVE.renderParams,
        },
        cellRendererFramework: StateCellRenderer,
        csv: false,
    },
    {
        headerName: FIELDS.CUSTOM_CREATIVE_NAME.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.CUSTOM_CREATIVE_NAME.headerComponentParams,
        field: FIELDS.CUSTOM_CREATIVE_NAME.field,
        type: [leftPinnedColumn, editableColumn],
        editable: stubTrue,
        cellRendererFramework: EllipsisCellRenderer,
        cellRendererParams: { lines: 2 },
        cellEditorFramework: FIELDS.CUSTOM_CREATIVE_NAME.cellEditorFramework,
        valueFormatter: FIELDS.CUSTOM_CREATIVE_NAME.valueFormatter,
        accountConfigurations: { [FEATURE_FLAGS.SHOW_CUSTOM_DATA_IN_CREATIVE_FORM]: 'true' },
    },
    {
        headerName: FIELDS.CUSTOM_ID.label,
        field: FIELDS.CUSTOM_ID.field,
        type: [leftPinnedColumn, editableColumn],
        editable: stubTrue,
        cellRendererFramework: EllipsisCellRenderer,
        cellRendererParams: { lines: 2 },
        cellEditorFramework: FIELDS.CUSTOM_ID.cellEditorFramework,
        valueFormatter: FIELDS.CUSTOM_CREATIVE_NAME.valueFormatter,
        accountConfigurations: { [FEATURE_FLAGS.SHOW_CUSTOM_DATA_IN_CREATIVE_FORM]: 'true' },
    },
    {
        headerName: FIELDS.THUMBNAIL_URL.label,
        headerValueGetter: FormattedMessageHeaderRenderer,
        headerComponentParams: FIELDS.TITLE.headerComponentParams,
        field: FIELDS.THUMBNAIL_URL.field,
        type: [leftPinnedColumn, editableColumn],
        cellRendererFramework: ImageCellRenderer,
        cellRendererParams: {
            mode: IMAGE_CELL_RENDERER_MODES.DEFAULT,
        },
        singleClickEdit: false,
        width: 120,
        csv: FIELDS.THUMBNAIL_URL.csv,
    },
];

export const availableColumnDefinitions = normalizeColumnDefs(
    creativeLibraryReportColumnDefinition,
    CREATIVE_LIBRARY_REPORT_ID,
    withCreativeEditIndication
);
